var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',_vm._g(_vm._b({staticClass:"overflow-y-auto",class:{ 'pa-0': !_vm.padded, 'pa-4': _vm.padded },style:(_vm.style),attrs:{"fluid":""}},'v-container',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }